import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
  Stack, Link
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const GalleryModal = ({ open, onClose, example, onButtonAction }) => {
  const navigate = useNavigate();

  if (!example) return null;

  const handleButtonClick = (button) => {
    // Handle navigation
    if (button.path) {
      navigate(button.path);
      onClose();
    }
    // Handle external URLs
    else if (button.externalUrl) {
      window.open(button.externalUrl, "_blank");
    }
    // Handle custom actions
    else if (button.action && onButtonAction) {
      onButtonAction(button.action);
    }
    // Fallback to onClick if provided
    else if (button.onClick) {
      button.onClick();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="gallery-modal-title"
      aria-describedby="gallery-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: 700 },
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          overflow: 'auto'
        }}
      >
        {/* Close Button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
          <IconButton
            onClick={onClose}
            sx={{
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.04)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ px: 4, pb: 4 }}>
          {/* Title */}
          <Typography
            id="gallery-modal-title"
            variant="h4"
            component="h2"
            fontWeight="bold"
            gutterBottom
          >
            {example.title}
          </Typography>

          {/* Type Badge */}
          {example.type && (
            <Typography
              variant="body2"
              sx={{ px: 0, py: 0.5,
                color: 'black',
                borderRadius: 1, mb: 2
              }}
            >
              {"Visualization Type: "  + example.type}
            </Typography>
          )}

          <Divider sx={{ my: 2 }} />

          {/* Image */}
            {example.image && (
            <Box sx={{ position: 'relative', mb: 3 }}>
                <Box
                sx={{
                    width: '100%',
                    height: 300,
                    overflow: 'hidden',
                    bgcolor: '#f5f5f5'
                }}
                >
                <img
                    src={example.image}
                    alt={example.title}
                    style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                    }}
                />
                </Box>
                
                {/* Centered link under image */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Link
                    component="button"
                    onClick={() => handleButtonClick(example.buttons?.[0])}
                    sx={{
                    fontSize: '0.875rem',
                    color: '#1976d2',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                    }}
                >
                    View Full Visualization
                </Link>
                </Box> */}
            </Box>
            )}

          {/* Description */}
          <Typography
            id="gallery-modal-description"
            variant="body1"
            color="text.secondary"
            paragraph
            sx={{ lineHeight: 1.7 }}
          >
            {example.description}
          </Typography>

          {/* Additional Details */}
          {example.details && (
            <Typography
              variant="body1"
              color="text.secondary"
              paragraph
              sx={{ lineHeight: 1.7 }}
            >
              {example.details}
            </Typography>
          )}

          <Divider sx={{ my: 3 }} />

          {/* Action Buttons */}
          <Stack spacing={2}>
            {example.buttons && example.buttons.map((button, index) => (
              <Button
                key={index}
                variant={button.variant || 'contained'}
                color={button.color || 'primary'}
                size="large"
                fullWidth
                onClick={() => handleButtonClick(button)}
                startIcon={button.icon}
              >
                {button.label}
              </Button>
            ))}
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default GalleryModal;